/**
 * Базовые валидаторы по типам полей.
 *
 * Возвращают `{ valid: boolean, error?: string }`. Конкретный текст ошибки
 * можно переопределить через `error-message` атрибут на `<plp-field>`.
 */

export interface ValidationResult {
  valid: boolean;
  error?: string;
}

import { t } from '../i18n/index.js';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateRequired(value: string): ValidationResult {
  if (value.trim() === '') {
    return { valid: false, error: t('form.validation.required') };
  }
  return { valid: true };
}

export function validateEmail(value: string): ValidationResult {
  if (!EMAIL_RE.test(value.trim())) {
    return { valid: false, error: t('form.validation.email') };
  }
  return { valid: true };
}

export function validatePattern(value: string, pattern: string): ValidationResult {
  try {
    const re = new RegExp(`^(?:${pattern})$`);
    if (!re.test(value)) {
      return { valid: false, error: t('form.validation.pattern') };
    }
  } catch {
    return { valid: true };
  }
  return { valid: true };
}

export function validateLength(value: string, min?: number, max?: number): ValidationResult {
  if (typeof min === 'number' && value.length < min) {
    return { valid: false, error: t('form.validation.minLength', { count: min }) };
  }
  if (typeof max === 'number' && value.length > max) {
    return { valid: false, error: t('form.validation.maxLength', { count: max }) };
  }
  return { valid: true };
}
